import { IconClockFilled } from '@iwoca/icons';
import { t } from '@lingui/macro';
import { differenceInCalendarDays } from 'date-fns';
import { useLocale } from 'hooks/useLocale';
import { TApplication } from 'lendingApi/applications.types';
import { showExpiryDate } from '../../ApplicationsTableState.context.helpers';
import styles from './ExpiryDateCell.module.css';

type TProps = {
  date?: string;
  application: TApplication;
};

export const ExpiryDateCell = ({ date, application }: TProps) => {
  const { i18n } = useLocale();
  const applicationStatus = application?.status;

  const todaysDate = new Date().toISOString().split('T')[0]; // 'yyyy-MM-dd'
  const expiryDate = date ? date : null;

  const daysTilExpiry =
    expiryDate &&
    differenceInCalendarDays(new Date(expiryDate), new Date(todaysDate));

  const shouldShowExpiryDate = showExpiryDate(applicationStatus);

  const showExpiringSoon =
    daysTilExpiry !== null &&
    daysTilExpiry !== '' &&
    daysTilExpiry >= 0 &&
    daysTilExpiry <= 5 &&
    shouldShowExpiryDate;

  const renderExpiryMessage = (amountOfDays: number | null) => {
    if (amountOfDays === 0) {
      return t`Expires today`;
    }
    if (amountOfDays === 1) {
      return t`Expires tomorrow`;
    }
    return t`Expires in ${amountOfDays} days`;
  };

  const renderFormattedDate = (date: string) =>
    i18n.date(date, {
      day: '2-digit',
      month: 'short',
      year: '2-digit',
    });

  const renderExpiryDate = (expiryDate: string) => {
    if (showExpiringSoon) {
      return (
        <div className={styles.expiringContainer}>
          <IconClockFilled className={styles.icon} />
          <div className={styles.expiringMessages}>
            <p>{renderExpiryMessage(daysTilExpiry)}</p>
            <p>({renderFormattedDate(expiryDate)})</p>
          </div>
        </div>
      );
    }
    return <p>{renderFormattedDate(expiryDate)}</p>;
  };

  return (
    <div className={styles.expiringContainer} data-testid="expiring-dates">
      {expiryDate && shouldShowExpiryDate ? renderExpiryDate(expiryDate) : '-'}
    </div>
  );
};
